<template>
  <div>
    <h3 class="md-heading">VOI Data Summary</h3>
    <div class="employee-details">
      <p>Employment info found for: {{ voi_data[0].employeeInformation.name.firstName }} {{ voi_data[0].employeeInformation.name.lastName }}</p>
      <p>Most recent employment: {{ voi_data[0].employerInformation[0].employerName }} ({{ voi_data[0].employerInformation[0].address.city }})</p>
    </div>
  </div>
</template>
<script>
import { mapGetters } from "vuex";
import LoadingIconTextButton from "@/components/LoadingIconTextButton";

export default {
  components: {
  LoadingIconTextButton,
  },
  props: ['voi_data'],
  computed: {
    ...mapGetters({
        application: "application",
    }),
  },
  showErrorDialog(message, title = "Error") {
      this.error_dialog.show = true;
      this.error_dialog.title = title;
      this.error_dialog.content = message;
  },
};
</script>

<style scoped lang="scss">
  .md-heading {
    margin-top: 0;
  }
  .employment-details {
    margin-left: 5%;
    margin-top: 50px;
  }

</style>
